import { render, staticRenderFns } from "./ActivitiesView.vue?vue&type=template&id=362e2534&scoped=true&"
import script from "./ActivitiesView.vue?vue&type=script&lang=js&"
export * from "./ActivitiesView.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesView.vue?vue&type=style&index=0&id=362e2534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e2534",
  null
  
)

export default component.exports